import React from "react";
import { useEffect, useState } from "react";

import { connect } from "react-redux";

import Loader from "../../components/Loader";

import {
    setFeaturedNewProduct,
    setFeaturedNewFalse,
} from "../../redux/actions/products";
import { setAlert } from "../../redux/actions/alerts";

import FeaturedTable from "../Shared/FeaturedTable";
import FeaturedProductFormRow from "./Forms/FeaturedProductFormRow";
import DeleteForm from "./Forms/DeleteForm";
import Modal from "../Shared/Modal";

import styles from '../../styles/pages/FeaturedContentPages/NewProductsPageContent.module.css'


const FeaturedProductForm = ({
    setAlert,
    setFeaturedNewProduct,
    setFeaturedNewFalse,
    product: { isLoading, featuredProductsNewProduct },
}) => {
    
    const [isDisabled, setIsDisabled] = useState(false);
    
    const [missingIndex, setMissingIndex] = useState([])
    const [clear, setClear] = useState(0);
    const [selectedContent, setSelectedContent] = useState(null);

    const defaultFeatured = {
        select: null,
        date: null,
        id: null
    }
    const [formValues, setFormValues] = useState([
        defaultFeatured,
        defaultFeatured,
        defaultFeatured,
        defaultFeatured,
    ])
    
    useEffect(() => {
        let currentForm = []

        if (featuredProductsNewProduct?.length > 0) {
        
            for (let featured of featuredProductsNewProduct) {
                if (!featured.new_product_expiration_date) {
                    continue
                }

                currentForm = [
                    ...currentForm,
                    {
                        select: featured.new_product_item_order,
                        date: featured.new_product_expiration_date,
                        id: featured.product_id,
                        name: featured.name,
                        featuredId: featured.product_id
                    }
                ]
            }

            if (currentForm.length === 0) {
                currentForm = [defaultFeatured]
            }
        } 
        
        setFormValues([
        ...currentForm
        ])

    }, [featuredProductsNewProduct]);
  
    const checkIsEmpty = (i) => {
        const currentForm = formValues[i]

        if (!currentForm || (!currentForm[`select`] && !currentForm[`date`] && !currentForm[`id`] && !currentForm[`name`])) {
            return true
        } else {
            return false
        }
    }

    const validateFields = () => {
        let missing = false
        let missingIndex = []
        for (let i = 0; i < formValues.length; i++) {
            const currentForm = formValues[i]

            if ((!currentForm[`select`] || !currentForm[`date`] || !currentForm[`id`] && !currentForm[`name`]) && !checkIsEmpty(i)) {

                missing = true
                missingIndex.push(i)
            }
        }

        setMissingIndex([...missingIndex])
        return missing

    };

    const processChange = (changingData, i) => {


        let dataToChange = formValues
        dataToChange[i] = {
            ...dataToChange[i],
            ...changingData
        }

        setFormValues([...dataToChange])
    }

    const handleClear = (i) => {
        let dataToChange = formValues

        if (dataToChange[i]?.featuredId) {
            return setSelectedContent(dataToChange[i])
        }
    
        dataToChange.splice(i, 1)
        
        setFormValues([...dataToChange])
        setMissingIndex([])
    }

    const handleSubmit = async () => {
        if (validateFields()) {
            setAlert("Please fill out all fields below");
        } else {
            setIsDisabled(true);
            setTimeout(() => {
                setIsDisabled(false);
            }, 3000);

            let removedFeatured = await setFeaturedNewFalse();
            let featuredNewProduct = {};
            let productId = null;
            // Loops through the formValue state and fires off requests for each product
            // formValues[product][`${product}-select`]  will dynamically grab the specific properties on the formValue obj
            for (let i = 0; i < formValues.length; i++) {
                if (checkIsEmpty(i)) {
                    continue
                }
                
                featuredNewProduct.order = formValues[i][`select`];
                featuredNewProduct.expiration_date = formValues[i][`date`];
                productId = formValues[i].id;
                setFeaturedNewProduct(productId, featuredNewProduct);
            }
            setClear(prevClear => prevClear + 1)
            setMissingIndex([])
        }
    };
  
    return isLoading ? (
        <Loader />
    ) : (
        <>
            <FeaturedTable
                tableName={'Featured Products - New Product Page'}
                subTitle={
                    <p className={styles.featured_table_sub_header}>If new products are expired, it will fill the remaining slots with "Default Products", which are set in the next tab.  Please ensure the product you feature has at least 1 image. Since they are displayed on DPS.</p>
                }
                addButtonName={'New Featured'}
                featuredData={formValues}
                FeaturedForm={FeaturedProductFormRow}
                handleSubmit={handleSubmit}
                handleChangeData={processChange}
                defaultFeatured={defaultFeatured}
                setFeaturedData={setFormValues}
                missingIndex={missingIndex}
                clearFeaturedRow={handleClear}
                clear={clear}
                addedStyles={{maxWidth: '1920px'}}
                disabled={isDisabled}
                setSelectedContent={setSelectedContent}
            />
            <Modal
                open={selectedContent ? true : false}
                setOpen={() => setSelectedContent(null)}
                component={<DeleteForm
                    selectedContent={selectedContent}
                    updatedData={{
                        new_product_featured: false,
                        new_product_expiration_date: null,
                        new_product_item_order: null,
                    }}
                    handleClose={() => setSelectedContent(null)}
                />} 

            />
        </>
  );
};

const mapStateToProps = (state) => ({
    product: state.product,
});

export default connect(mapStateToProps, {
    setAlert,
    setFeaturedNewProduct,
    setFeaturedNewFalse,
})(FeaturedProductForm);
